import React from "react";
import Service_outer_card from "../../../Common_Component/Service_outer_card/Service_outer_card";

function Print_Media() {


  const data = [
    {
      id : 1,
      title: "Billboards and Hoardings",
      description: "Billboards and hoardings are powerful tools for high-impact outdoor advertising. With large, eye-catching visuals & strategic placements...",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/billboard.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img1.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 2,
      title: "Bus Wrapping",
      description: "Bus wrapping is a dynamic and eye-catching advertising solution that turns public transportation into moving billboards.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/bus.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img2.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 3,
      title: "Bus Shelter",
      description: "Bus shelter advertising transforms every day waiting areas into prime advertising spaces.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/busshelter.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img3.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 4,
      title: "Auto Rikshaw Back",
      description: "Auto rickshaw back advertising is a cost-effective and impactful way to promote your brand across urban and suburban areas.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/AUTO-RICKSHAW-AD.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img4.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 5,
      title: "Brochures and Flyers",
      description: "Bus wrapping is a dynamic and eye-catching advertising solution that turns public transportation into moving billboards.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/broucherFlyers.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img5.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 6,
      title: "Leaflets",
      description: "Leaflets are simple, cost-effective marketing tools that are perfect for delivering concise, targeted messages to your audience.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/LEAFLETS.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img6.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 7,
      title: "Catalogues",
      description: "Catalogues are powerful marketing tools designed to showcase your products, services, or offerings in a professional, organized, and visually...",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/CATLOGUES.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img7.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 8,
      title: "Banners",
      description: "Banners are a versatile and impactful advertising tool that can be used for a variety of purposes, from promoting events to displaying special offers.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/BANNERS.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img8.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 9,
      title: "Roll-up Standees",
      description: "Roll-up standees are an efficient and highly portable solution for displaying your brand, products, or promotions in a variety of settings.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/rollup.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img9.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 10,
      title: "Sun Boards",
      description: "Sun boards are a durable and lightweight material perfect for outdoor and indoor signage.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/SUB-BOARD.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img10.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 11,
      title: "Newspaper Inserts",
      description: "Newspaper inserts are a highly effective way to target a broad audience by placing promotional materials directly inside newspapers.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/NEWSPAPER-INSERTS.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img11.png",
      baseLink: "/print-Media-services"
    },

    {
      id : 12,
      title: "Labels and Stickers",
      description: "Labels & stickers are powerful marketing tools that offer versatility and brand visibility in a fun, creative, and cost-effective way.",
      bgImgSrc: "/Assets/Images/Service/Services/printmedia/LABELS-&-STICKERS.png",
      MainImgSrc: "/Assets/Images/Service/Services/printmedia/img12.png",
      baseLink: "/print-Media-services"
    }

  ]

  return (
    <>
      <section className="Multimedia_Advertising Print_Media">
        <div className="row">


          {data?.length > 0 && data?.map((item) => {
            return (
              <div className="col-xl-4 col-md-6">
                <Service_outer_card title={item?.title} description={item?.description} bgImgSrc={item?.bgImgSrc} MainImgSrc={item?.MainImgSrc} baseLink={item?.baseLink} id={item?.id} />
              </div>
            )
          })}

          {/* <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div>

          <div className="col-xl-4 col-md-6">
            <Service_outer_card />
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Print_Media;
